import { IArticle, PrescriptionType } from '@alberta/konexi-shared';

export function articleIsForUse(article: IArticle): boolean {
  if (!article) {
    return false;
  }
  return article.prescriptionType === PrescriptionType.AidsForUse;
}
